<template>
    <b-container>
        <b-button class="mb-3 mt-3" @click="crearRol($event.target)" >Crear nuevo rol</b-button>
        <b-table 
             striped hover 
             :items="items" 
             :fields="fields"
             :current-page="currentPage"
             :per-page="perPage"

             :sort-by.sync="sortBy"
             :sort-desc.sync="sortDesc"
             :sort-direction="sortDirection"

            >
            <template v-slot:cell(acciones)="row">
                <b-button size="sm" class="mb-1" @click="editar(row.item, row.index, $event.target)"
                    data-toggle="tooltip" data-placement="top" title="Edita el rol del sistema."
                >
                    Editar
                </b-button>
            </template>
            <template v-slot:cell(permiso)="row">
                <b-form-checkbox v-model="row.detailsShowing" @change="row.toggleDetails">
                    ver detalles
                </b-form-checkbox>               
            </template>

            <template v-slot:row-details="row">
                <b-card>
                    <ul v-for="(value, key) in permisos" :key="key"><!--row.item -->
                        <li v-if=" value.idroles == row.item.id" >
                   
                            {{value.descripcion}}
                        </li>
                    </ul>
                </b-card>
            </template>


        </b-table>
         <!-- Info modal -->
        <b-modal :id="infoModal.id"  :title="infoModal.title" @show="resetModal" @hidden="resetModal" @ok="handleOk">
            <form ref="form" @submit.stop.prevent="handleSubmit">  
                <b-form-group id="input-group-1" label="Nombre del rol:" label-for="input-1">
                    <b-form-input
                        id="input-1"
                        v-model="infoModal.description"
                        name="description"
                        v-validate="'required|min:3 '" 
                        :state="$parent.validateState('description')"
                        placeholder="Tu respuesta"
                    ></b-form-input>

                    <b-form-invalid-feedback>
                        {{  errors.first('description') }}
                    </b-form-invalid-feedback>
                </b-form-group>
            </form>  
        </b-modal>
        <!-- Paginacion -->
        <b-pagination
            v-model="currentPage"
            :total-rows="items.length"
            :per-page="perPage"
            align="center" 
            class="my-0"
        >
        </b-pagination>
       
    </b-container>
</template>

<script>
    import {mapActions,mapMutations} from 'vuex'
    import userForm from '@/components/admin/userForm'
    import validateMixin from '@/mixins/validation' //para usar el mixin de vee-validate
    export default {
        components:{
            userForm
        },  
        mixins : [validateMixin],
        props:{
            items:{
                type: Array,
                required: true
            },
            fields:{
                type: Array,
                required:true
            },
            permisos:{
                type: Array,
                required: true  
            }
        },
        data:function(){
            return{
                currentPage: 1,
                perPage: 5,
                pageOptions: [10, 50, 100],
                sortBy: '',
                sortDesc: false,
                sortDirection: 'asc',
                // valor de los roles
                options: [
                  {value:1, text:'Admin'},
                  {value:2, text:'Vendedor'},
                  {value:3, text:'Ingenieria'},
                  {value:4, text:'Prensa'}
                ],
                //variable del modal
                infoModal: {
                    id: 'info-modal',
                    title: '',
                    description: ''
                },
                item:[],
                
            }
        },
        methods:{
            ...mapActions({
                _crearRol: 'roles/crearRol'   
            }),
            ...mapMutations({
                _setRol: 'roles/setRol'
            }),
            eliminar(item, index, button){
                this._eliminar(item).then(() => {
                   //  
                })
            },
            editar(item, index, button){
                this._setRol(item)
                this.$router.push('editar_roles')
            },
            crearRol(button){
                this.infoModal.title = `Crear un nuevo rol`
                this.$root.$emit('bv::show::modal',this.infoModal.id, button)
            },
            resetModal() {
               this.infoModal.description = ''    
            },
            handleOk(bvModalEvt) {

              // Prevent modal from closing
              bvModalEvt.preventDefault()
              // Trigger submit handler
              this.handleSubmit()
            },
            checkFormValidity() {
                const valid = this.$refs.form.checkValidity()
                this.infoModal.passwordState = valid
                return valid
            },
            handleSubmit() {
               let payload
                // si no es valido sale de la funcion
               if (!this.checkFormValidity()) {
                 return
               }
                payload =
                    {
                    'description' : this.infoModal.description
                    }
                this._crearRol(payload).then(() =>{
                     this.$bvModal.hide('info-modal')
                })

               // Hide the modal manually
              /* this.$nextTick(() => {
                
               })*/
            },
        }
        
    }
</script>

<style lang="scss" scoped>

</style>